import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import {RichText, Button} from '@synergycms_core/components/generic';

const HotelInfoButton = class HotelInfoButton extends React.Component {
    static displayName = 'HotelInfoButton';
    render() {
        const { config } = this.props;
        const { urlHotel, deviceType } = config;
        const text = deviceType === 'MOBIL' || deviceType === 'TABLET' ? '_%ver hotel%_' : '_%ver info del hotel%_';
        return (
            <Button onClick={() => window.open(urlHotel, '_blank')} innerStyle={[deviceType === 'DESK' ? 'searchOptionsHotelLink' : '']} ariaLabel={text} translate={true} id={'td-d1-hotel-subh-00'}>
                <RichText
                    text={text}
                    translate={true}
                    ucFirst={true}
                    innerStyle={['roboto13Black', 'mainColor']}
                />
            </Button>
        );
    }
};
export default compose(
    PropertyManager(['langCode', 'urlHotel', 'deviceType'])
)(HotelInfoButton);
